import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Box from '@material-ui/core/Box';

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import {ArrowUpward, ChevronRight} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

import MaterialTable from 'material-table';
import Search from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import CustomCheckBox from 'components/elements/CustomCheckBox2'
import { isAdmin } from 'utils';

const useStyles = makeStyles((theme) => ({
    formFields: {
        height: '100%',
        width: '100%',
        flexDirection: 'row',
        
        alignItems: 'flex-start',
        paddingTop: '50px',
    },
    editorWrapper: {
        height: '100%',
        width: '100%',
        padding: theme.spacing(3.25, 4, 4, 4),
    },
    description: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '10px',
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: '0.06px',
        marginLeft: '30px',
    },
    errorMessage: {
        fontSize: 13,
        color: theme.palette.primary.red,
    },
}));

function RoleUpdate(props) {
    const classes = useStyles();

    const {
        userUseCases,
        useCases,
        rowClickHandel,
        headerClickHandel,
        headerChecked,
        handleChange,
        updatedRole,
        error,
        readOnly,
        subjects,
        user
    } = props;

    const {t} = useTranslation();

    return (
        <div className={classes.formFields}>
            <form autoComplete='off'>
                <Box mb={2} height="100%" width="100%">
                    <Grid container spacing={2} sm={12}>
                        <Grid container spacing={1} sm={3} style={{marginLeft: "auto", marginRight: "auto"}}>
                            <Grid item xs sm={12} spacing={1} >
                                <TextField
                                    style={{height: '80px'}}
                                    autoFocus
                                    helperText={error && error.name
                                        ?
                                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                        : null}
                                    fullWidth
                                    required
                                    disabled={readOnly}
                                    id="name"
                                    value={updatedRole.name || ''}
                                    onChange={handleChange('name', false)}
                                    label={t('NAME')}/>

                                <FormControl fullWidth disabled={false} style={{height: '80px'}}>
                                    <InputLabel id="role-active">
                                        {t('ROLE_ACTIVE')}
                                    </InputLabel>
                                    <Select
                                        autoWidth
                                        disabled={readOnly}
                                        value={updatedRole.active || ''}                                        
                                        id="active"
                                        onChange={handleChange('active', true)}
                                    >
                                        <MenuItem value=''>-</MenuItem>
                                        <MenuItem value={'true'}>{t('YES')}</MenuItem>
                                        <MenuItem value={'false'}>{t('NO')}</MenuItem>
                                    </Select>
                                    <FormHelperText>  {error && error.active && (
                                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                    )}</FormHelperText>
                                </FormControl>

                                <FormControl fullWidth disabled={false} style={{height: '80px'}}>
                                    <InputLabel id="role-admin">
                                        {t('ADMIN_ROLE')}
                                    </InputLabel>
                                    <Select
                                        autoWidth
                                        disabled={readOnly}
                                        value={updatedRole.admin || ''}
                                        id="admin"
                                        onChange={handleChange('admin', true)}
                                    >
                                        <MenuItem value=''>-</MenuItem>
                                        <MenuItem value={'true'}>{t('YES')}</MenuItem>
                                        <MenuItem value={'false'}>{t('NO')}</MenuItem>
                                    </Select>
                                    <FormHelperText>  {error && error.admin && (
                                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                    )}</FormHelperText>
                                </FormControl>

                                <FormControl fullWidth disabled={false} style={{height: '80px'}}>
                                    <InputLabel id="role-subject">
                                        {t('SUBJECT')}
                                    </InputLabel>
                                    <Select
                                        autoWidth
                                        disabled={readOnly}
                                        value={updatedRole.subjectId || ''}
                                        id="select-role-subject"
                                        onChange={handleChange('subjectId', true)}
                                    >
                                        {isAdmin(user) &&
                                            <MenuItem value=''>-</MenuItem>
                                        }
                                        { subjects.map((subject) => (
                                                <MenuItem value={subject.subjectId}>{subject.name}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                    <FormHelperText>  {error && error.admin && (
                                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                    )}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container alignItems="stretch" spacing={2} sm={9}
                                style={{marginLeft: "auto", marginRight: "auto"}}>

                            <Typography variant="button" className={classes.description}>
                                {t('CHOOSE_UC')}
                            </Typography>

                            <div className={classes.editorWrapper}>
                            
                                <MaterialTable
                                    title=""
                                    search="false"
                                    icons={{
                                        SortArrow: ArrowUpward,
                                        DetailPanel: ChevronRight,
                                        Search: Search,
                                        ResetSearch: Clear
                                    }}
                                    data={useCases}

                                    columns={[
                                        { title: t('MODULE'), field: 'module' },
                                        { title: t('UC_CODE'), field: 'code' },
                                        { title: t('UC_NAME'), field: 'description' },
                                    ]}
                                    parentChildData={(row, rows) => rows.find(a => a.useCaseId === row.parentId)}

                                    options={{
                                        showTitle: false, paging:false, showTextRowsSelected:false,
                                        headerStyle: {
                                            position: "sticky",
                                            top: "0"
                                        },
                                        maxBodyHeight: "500px",
                                        
                                        toolbarButtonAlignment:"left"
                                    }}

                                    actions={[
                                        {
                                            icon: 'checked',
                                            tooltip: 'checked',
                                            onClick: (event, rowData) => {rowClickHandel(rowData)}
                                        },
                                        {
                                            icon: 'checkAll',
                                            tooltip: 'check all',
                                            onClick: (event, rowData) =>  headerClickHandel(),
                                            isFreeAction: true,
                                        },
                                    ]}

                                    localization={{
                                        header: {
                                            actions: ''
                                        },
                                    }}

                                    components={{
                                        Action: props => (
                                          <CustomCheckBox
                                            onClick={(event) => props.action.onClick(event, props.data)}
                                            color={'white'}
                                            iconNumber={props.data.useCaseId?props.data.checked:headerChecked}
                                            paddingTop={props.data.useCaseId?'0':'8px'}
                                            paddingLeft={props.data.useCaseId?'0':'30px'}
                                            width='5'
                                            height='5'
                                            text={props.data.useCaseId?'':t('CHECK_ALL')}
                                          />
                                        )
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </div>
    )
}

RoleUpdate.propTypes = {};
RoleUpdate.defaultProps = {};


const mapStateToProps = (store) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RoleUpdate);


